<template>
	<div></div>
</template>

<script>
import store from '../store'
import { post } from '../helpers/api'
import { enablePushNotifications, getPushToken } from '@/api/device'
import { pushNotification } from '../helpers/pushNotification'
import {
	initPusher,
	subscribeToPrivateUser,
	bindChannelEventWithChunking,
	bindChannelAppEvents,
} from '@/helpers/pusher'

export default {
	data() {
		return {
			store,
			notificationsEnabled: false,
			totalUnread: 0,
		}
	},

	async created() {
		if (!('Notification' in window)) {
			this.notificationsEnabled = false
		} else if (Notification.permission === 'granted') {
			this.notificationsEnabled = true
		} else if (Notification.permission !== 'denied') {
			this.notificationsEnabled = false
		} else {
			this.notificationsEnabled = false
		}

		if (this.store.auth.user?.hasactivity) {
			initPusher()
		}

		if (
			this.store.config.wrapper &&
			this.store.auth.user?.hasactivity &&
			!getPushToken()
		) {
			await enablePushNotifications()
			this.listenForNotifications()
		} else if (
			this.store.config.wrapper &&
			this.store.auth.user?.hasactivity &&
			getPushToken()
		) {
			this.listenForNotifications()
		}

		if (
			(this.notificationsEnabled && this.store.auth.user.hasactivity) ||
			(this.store.config.wrapper && this.store.auth.user.hasactivity)
		) {
			this.$pusher.connection.bind('connected', this.initPusher)
			this.$pusher.connection.bind('connected', this.loadUnreadCounts)
		}
	},

	mounted() {
		if (!this.store.auth.user?.hasactivity) {
			this.loadUnreadCounts()
		}
	},

	watch: {
		totalUnread: function () {
			let data = { type: 'unreadUpdate', unread: this.totalUnread }
			this.postFromIframe(data)
		},
	},

	methods: {
		initPusher() {
			var userChannel = subscribeToPrivateUser()

			//unbind any orphaned events
			userChannel.unbind()

			bindChannelAppEvents(userChannel, {
				BubbleStats: this.bubbleStatsHandler,
				AnnouncementAdded: this.loadUnreadCounts,
				TaskAdded: this.loadUnreadCounts,
				TaskRemoved: this.loadUnreadCounts,
			})
		},

		listenForNotifications() {
			const { user } = this.store.auth
			// Subscribe to the push channel
			if (!getPushToken() || !user.hasactivity) {
				return
			}

			const pushChannelName = `private-push.${user.id}.${getPushToken()}`
			const pushChannel = this.$pusher.subscribe(pushChannelName)
			// unbind first: the subscription_error retry below re-runs this
			// method on the same channel and would stack duplicate handlers
			pushChannel.unbind()
			bindChannelEventWithChunking(
				pushChannel,
				'App\\Events\\PushNotification',
				this.pushNotificationHandler
			)
			pushChannel.bind('pusher:subscription_error', (status) => {
				console.error(
					'\n\nGetting an error trying to connect to the PushNotification event in WrapperManager.vue.\n\n'
				)
				setTimeout(this.listenForNotifications, 5000)
			})
		},

		pushNotificationHandler(data) {
			this.postFromIframe({ type: 'newMessage', messageData: data })

			var notification = pushNotification(data)
			if (notification) {
				notification.onclick = () => {
					parent.focus()
					window.focus() //just in case, older browsers

					if (data.bubble_id) {
						this.$router.push('/recents/' + data.bubble_id)
					}

					// this.close();
				}
			}
		},

		bubbleStatsHandler(data) {
			this.loadUnreadCounts()
		},

		postFromIframe(msg) {
			window.parent.postMessage(msg, '*')
		},

		loadUnreadCounts() {
			post('/api/v1/user.badgecount', {})
				.then(({ data }) => {
					this.totalUnread = data.badgecount
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
}
</script>
